import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const SimpleButton = styled.div`
  font-size: 10px;
  line-height: 12px;
  text-align: right;
  color: ${ColorPalette.HEX.Manatee};
  padding-right: 21px;
  background: url('/corporate/images/payment/icon-help.svg');
  background-position: center right;
  background-repeat: no-repeat;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 32px;
`;
